export default {
    title: 'Proizvodi',
    headerActions: {
        sortFilters: {
            newest: 'Najnovije',
            mostOrdered: 'Najviše naručivano',
            priceLow: 'Cijena od najmanje do najveće',
            priceHigh: 'Cijena od najveće do najmanje',
        },
        search: 'Pretraži',
        products: 'proizvoda',
        filtersMobileButton: 'Filteri'
    },
    productItem: {
        notAvailable: 'Nedostupno',
        notDelivering: 'Nema dostave',
        ratings: 'ocjena',
        button: {
            addToCart: 'Dodaj u korpu',
            notify: 'Obavijesti me'
        },
        from: 'od',
        to: 'do'
    },
    sidebar: {
        title: 'Filter proizvoda',
        resetAllButton: 'Resetuj sve',
        filter: {
            showAllButton: 'Prikaži sve',
            showLessButton: 'Prikaži manje',
            categories: {
                title: 'Kategorije prodavnica',
            },
            manufacturer: {
                title: 'Brend',
                searchPlaceholder: 'Pretraži brendove',
            },
            price: {
                title: 'Cijena'
            },
            rating: {
                title: 'Ocjena'
            },
            currentlyAvailable: {
                title: 'Trenutno dostupno'
            },
            discounts: {
                title: 'Popusti',
                allDiscounts: 'Svi popusti',
                andMore: 'i još'
            }
        }
    }
}
